import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import 'antd/dist/reset.css';
import './App.css';

// 组件导入
import Header from './components/Header';
import FooterItem from './components/FooterItem';

// 页面导入
import Home from './pages/Home';
import About from './pages/About';
import Archive from './pages/Archive';
import Auth from './pages/Auth';
import PostDetail from './pages/PostDetail';
import WritePost from './pages/WritePost';
import NotFound from './pages/NotFound';

const { Content } = Layout;

function App() {
  return (
    <ConfigProvider locale={zhCN} theme={{ token: { colorPrimary: '#43b8a1ff' } }}>
      <Router>
        <Layout className="layout">
          <Header />
          <Content className="content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/archive" element={<Archive />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/post/:id" element={<PostDetail />} />
              <Route path="/write" element={<WritePost />} />
              <Route path="/edit/:id" element={<WritePost />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Content>
          <FooterItem />
        </Layout>
      </Router>
    </ConfigProvider>
  );
}

export default App;